
define(
  'UnlockCommerce.DataLayer.DataLayer'
  , [
    'Tracker',
    'GoogleTagManager',
    'Utilities.ResizeImage',
    'underscore',
    'LiveOrder.Model',
    'Profile.Model',
    'Klaviyo.Model',
    'js.cookie',
    'Backbone',
    'Configuration',
    'DataLayer.Model'
  ]
  , function (
    Tracker,
    GoogleTagManager,
    resizeImage,
    _,
    Liveorder,
    ProfileModel,
    KlaviyoModel,
    Cookies,
    Backbone,
    Configuration,
    DataLayerModel
  ) {
    'use strict';

    function processGTMJS() {
      var profile = ProfileModel.ProfileModel && ProfileModel.ProfileModel.getInstance() || ProfileModel.getInstance();
      var userData, addresBook, countryName, regionName, shipAddr, phone,
        additionalAddress;
      // eslint-disable-next-line
      var gtmjs = _.find(dataLayer, function (event) {
        return event.event === 'gtm.js';
      });
      var isLoggedIn = profile.get('isLoggedIn');
      if (gtmjs && isLoggedIn === 'T') {
        // AdressBook from Cart
        addresBook = profile.get('addressbook');
        if (!addresBook) {
          addresBook = profile.get('addresses').models[0];
        }

        if (addresBook instanceof Array) {
          shipAddr = _.find(addresBook, function (address) {
            return address.defaultshipping === 'T';
          });
        } else {
          addresBook = profile.get('addresses').models;
          shipAddr = _.find(addresBook, function (address) {
            return address.attributes.defaultshipping === 'T';
          });
        }

        // Country and region names
        if (shipAddr) {
          // eslint-disable-next-line
          countryName = shipAddr.country !== undefined
            ? SC.ENVIRONMENT.siteSettings.countries[shipAddr.country].name
            : SC.ENVIRONMENT.siteSettings.countries[shipAddr.attributes.country].name;
          // eslint-disable-next-line
          regionName = shipAddr.country !== undefined
            ? _.find(SC.ENVIRONMENT.siteSettings.countries[shipAddr.country].states, function (state) {
              return state.code === shipAddr.state;
            }).name
            : _.find(SC.ENVIRONMENT.siteSettings.countries[shipAddr.attributes.country].states, function (state) {
              return state.code === shipAddr.attributes.state;
            }).name;
          if (shipAddr.phone) {
            phone = shipAddr.phone;
          } else if (shipAddr.attributes && shipAddr.attributes.phone) {
            phone = shipAddr.attributes.phone;
          }
          // eslint-disable-next-line
          var additionalAddres2 = shipAddr.addr2 !== undefined
            ? shipAddr.addr2 === null ? '' : shipAddr.addr2
            : shipAddr.attributes && shipAddr.attributes.addr2 === null ? '' : shipAddr.attributes && shipAddr.attributes.addr2;
          // eslint-disable-next-line
          var additionalAddres3 = shipAddr.addr3 !== undefined
            ? shipAddr.addr3 === null ? '' : shipAddr.addr3
            : shipAddr.attributes && shipAddr.attributes.addr3 === null ? '' : shipAddr.attributes && shipAddr.attributes.addr3;
          additionalAddress = additionalAddres2 + ' ' + additionalAddres3;
        }
        if (!phone && profile.get('phoneinfo')) {
          phone = profile.get('phoneinfo').phone || profile.get('phoneinfo').altphone;
        }
        userData = {
          profileId: profile.get('internalid'),
          firstName: profile.get('firstName'),
          lastName: profile.get('lastName'),
          email: profile.get('email'),
          // when in shopping, addressee and attention should be populated to get company from address
          companyName: shipAddr && shipAddr.attention && shipAddr.addressee ||
						// when in checkout and myaccount this is the attr for company from address
						shipAddr && shipAddr.company ||
						profile.get('companyname'),
          /* eslint-disable */
          address: shipAddr && (shipAddr.addr1 !== undefined ? shipAddr.addr1 : shipAddr.attributes.addr1),          
          city: shipAddr && (shipAddr.city !== undefined ? shipAddr.city : shipAddr.attributes.city),          
          zip: shipAddr && (shipAddr.zip !== undefined ? shipAddr.zip : shipAddr.attributes.zip),          
          regionCode: shipAddr && (shipAddr.state !== undefined ? shipAddr.state : shipAddr.attributes.state),          
          countryCode: shipAddr && (shipAddr.country !== undefined ? shipAddr.country : shipAddr.attributes.country),
		  /* eslint-enable */
          country: countryName,
          region: regionName,
          addressAdditional: additionalAddress && additionalAddress.trim()
        };

        if (phone) {
          userData.phoneNumber = phone;
        }
        gtmjs.data = { user: userData, loggedIn: isLoggedIn === 'T' };
      } else {
        gtmjs.data = { loggedIn: isLoggedIn === 'T' };
      }
    }
    function convertToItemObj(item, line) {
      var selectedOptions = line.get('options').filter(function (option) {
        return option.get('value') && option.get('value').label;
      });
      var price = line.get('rate') || item.getPrice() && item.getPrice().price;
      var itemIfMatrix = item.get('itemoptions_detail') && item.get('itemoptions_detail').matrixtype &&
				item.get('itemoptions_detail').matrixtype === 'child' && item.get('_matrixParent');
      var category = getCategoryObject(itemIfMatrix || item);
      var imageUrl = item.get(Configuration.cloudinaryImageGallery.field).split(';')[0] !== ''
        ? item.get(Configuration.cloudinaryImageGallery.field).split(';')[0]
        : itemIfMatrix ? itemIfMatrix.get('_thumbnail') && itemIfMatrix.get('_thumbnail').url :
          '';
      // cust item below.
      var basePrice = item.get('pricelevel5');
      // cust item below.
      var brand = item.get('custitembrand') || item.get('manufacturer') || 'Nabco';
      if (!imageUrl) {
        var folderPathName = Configuration.cloudinaryImageGallery.notFoundFolder;
        var fileRoute = Configuration.siteSettings.touchpoints.home + folderPathName;
        var published = SC.published || SC.ENVIRONMENT.published;
        var notFoundImages = published && published.Categories;
        var commercecategory = item.get('commercecategory') && _.last(item.get('commercecategory').primarypath);
        var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
          return element.id === commercecategory.id;
        });
        if (notFoundImage) {
          imageUrl = fileRoute + notFoundImage.name;
        } else {
          imageUrl = item.get('_thumbnail') && item.get('_thumbnail').url;
        }
      }
      var resizedImage = imageUrl ? resizeImage(imageUrl, 'zoom') : '';
      var pathUrl = getItemURL(item, line);
      var itemVariants = _.map(selectedOptions, function (option) {
        return option.get('value').label;
      }).join(', ');
      var quantity = line.get('quantity') || item.get('quantityavailable');
      var amount = line.get('amount');

      if (line.getMatrixOptionsSelection && !_.isEmpty(line.getMatrixOptionsSelection())) {
        var matrixParentItem = line.get('item');
        pathUrl = getItemURL(matrixParentItem, line);
        resizedImage = matrixParentItem.get('_thumbnail') && matrixParentItem.get('_thumbnail').url &&
					resizeImage(matrixParentItem.get('_thumbnail').url, 'zoom');
        category = getCategoryObject(matrixParentItem);

        if (!basePrice) {
          basePrice = matrixParentItem.get('custitem53');
        }
      }

      var retVal = {
        name: item.get('_name'),
        sku: item.get('itemid'),
        id: item.get('itemid'),
        price: price,
        variant: itemVariants,
        url: pathUrl,
        quantity: quantity,
        categoryNames: category.categoriesName,
        imageUrl: resizedImage,
        brand: brand,
        basePrice: basePrice,
        category: category.primaryCategoryUrl
      };
      if (amount) {
        retVal.amount = amount;
      }
      return retVal;
    }
    function convertToGA4Item(product) {
      return {
        item_id: product.get('id'),
        item_name: product.get('name'),
        price: product.get('rate'),
        quantity: product.get('quantity')
      };
    }
    function getItemURL(item, line) {
      var retVal;
      var quantity = line.get('quantity');
      var itemUrlPath = item.get('_url');
      var originUrl = Backbone.history.location.origin;
      var itemOptionsUrl = '';

      if (line.get('options')) {
        itemOptionsUrl = quantity ? '&' : '?';
      }
      line.get('options').models.forEach(function (itemOption) {
        if (itemOption.get('value')) {
          itemOptionsUrl += itemOption.get('urlParameterName') + '=' + encodeURIComponent(itemOption.get('value').internalid) + '&';
        }
      });
      if (itemOptionsUrl) {
        itemOptionsUrl = itemOptionsUrl.slice(0, -1);
      }
      retVal = originUrl + itemUrlPath + (quantity ? '?quantity=' + quantity.toString() : '') + itemOptionsUrl;
      return retVal;
    }
    function getCategoryObject(item) {
      var categoryPath = item.get('commercecategory');
      var categoryNamesData = [];
      var primaryPath = categoryPath && categoryPath.primarypath;
      var primaryCategoryUrl;
      if (primaryPath) {
        primaryPath.forEach(function (category) {
          categoryNamesData.push(category.name);
        });
        primaryCategoryUrl = primaryPath && primaryPath[0] && primaryPath[0].urls[0];
      }
      return {
        primaryCategoryUrl: primaryCategoryUrl,
        categoriesName: categoryNamesData.reverse()
      };
    }
    function setCartIdCookie(orderModel) {
      !Cookies.get('proceedToCheckoutUniqueId') && Cookies.set(
        'proceedToCheckoutUniqueId',
        orderModel.operationIds && orderModel.operationIds[0].split('-').join('') + '_' + new Date().getTime().toString(),
        { expires: 365 }
      );
    }
    function getQuantityItemsId(internalId, linesLength) {
      var retVal;
      for (var i = 0; i < linesLength; i++) {
        var itemInternalId = internalId + '-' + i;
        if (typeof window.quantityItems[itemInternalId] !== 'undefined') {
          retVal = itemInternalId;
        }
      }

      return retVal;
    }
    function functionAddToCart(eventName, self, line, cartTotalParam, lengthToFixedParam, itemCounterParam) {
      var lengthToFixed = lengthToFixedParam;
      var cartTotal = cartTotalParam;
      var itemCounter = itemCounterParam;
      var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
      if (line) {
        var orderModel = Liveorder.getInstance();
        var items = orderModel.attributes.lines.models;
        var eventData = {
          event: eventName ? 'addToCart' : 'removeFromCart',
          ecommerce: {
            currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl
          },
          data: {
            items: [],
            total: 0
          }
        };

        if (eventName) {
          eventData.ecommerce.add = { products: [] };
        } else {
          eventData.ecommerce.remove = { products: [] };
        }

        items.forEach(function (innerLine) {
          var item = innerLine.get('item'), objectItem;
          var amount = innerLine.get('amount');
          cartTotal += amount;
          var stringAmount = amount.toString().split('.')[1];
          if (stringAmount && stringAmount.length > lengthToFixed) {
            lengthToFixed = 3;
          }

          if (innerLine.collection.length === itemCounter) {
            eventData.data.total = parseFloat(cartTotal.toFixed(lengthToFixed));
          }

          eventData.data.checkoutUrl = checkoutUrl;
          objectItem = convertToItemObj(item, innerLine);
          eventData.data.items.push(objectItem);

          if (innerLine.toProcess) {
            if (SC.Application.getComponent('PDP') && SC.Application.getComponent('PDP').getItemInfo()) {
              var currentQuantity = SC.Application.getComponent('PDP').getItemInfo().quantity;
              var newObjectItem = JSON.parse(JSON.stringify(objectItem));
              newObjectItem.quantity = currentQuantity;
              newObjectItem.amount = newObjectItem.quantity * newObjectItem.price;
              var index = newObjectItem.url.lastIndexOf('=');
              newObjectItem.url = newObjectItem.url.slice(0, index + 1) + newObjectItem.quantity;

            } else {
              var saveItem = _.find(window.cartLinesBefore, function (value) {
                return value.get('item').id === item.id;
              });
              if (saveItem) {
                newObjectItem = JSON.parse(JSON.stringify(objectItem));
                newObjectItem.quantity = Math.abs(objectItem.quantity - saveItem._previousAttributes.quantity);
                newObjectItem.amount = newObjectItem.quantity * newObjectItem.price;
              } else {
                newObjectItem = objectItem;
              }
            }
            eventName ? eventData.ecommerce.add.products.push(newObjectItem) : eventData.ecommerce.remove.products.push(newObjectItem);
            innerLine.toProcess = false;
          }
          itemCounter++;
        });
      }
      Tracker.trigger(eventName, eventData, line);
      self.pushData(eventData);
    }
    function setValuesUpdated(line, eventData, eventName, cartTotalParam, lengthToFixedParam, itemCounterParam, itemRemoved) {
      var itemCounter = itemCounterParam;
      var lengthToFixed =	lengthToFixedParam;
      var cartTotal = cartTotalParam;
      var item = line.get('item'), objectItem;

      if (eventName) {
        eventData.ecommerce.add = eventData.ecommerce.add || { products: [] };
      } else {
        eventData.ecommerce.remove = eventData.ecommerce.remove || { products: [] };
      }

      var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
      var amount = line.get('amount');

      cartTotal += amount;
      var stringAmount = amount.toString().split('.')[1];
      if (stringAmount && stringAmount.length > lengthToFixed) {
        lengthToFixed = 3;
      }

      if (line.collection.length === itemCounter) {
        eventData.data.total = parseFloat(cartTotal.toFixed(lengthToFixed));
      }

      eventData.data.checkoutUrl = checkoutUrl;
      // Items data
      objectItem = convertToItemObj(item, line);
      eventData.data.items.push(objectItem);

      if (line.toProcess) {
        if (itemRemoved) {
          eventData.ecommerce.remove.products.push(itemRemoved);
        }
        // Update quantity
        if (SC.Application.getComponent('PDP') && SC.Application.getComponent('PDP').getItemInfo()) {
          var currentQuantity = SC.Application.getComponent('PDP').getItemInfo().quantity;
          var newObjectItem = JSON.parse(JSON.stringify(objectItem));
          newObjectItem.quantity = currentQuantity;
          newObjectItem.amount = newObjectItem.quantity * newObjectItem.price;
          var index = newObjectItem.url.lastIndexOf('=');
          newObjectItem.url = newObjectItem.url.slice(0, index + 1) + newObjectItem.quantity;

        } else {
          var saveItem = _.find(window.cartLinesBefore, function (value) {
            return value.get('item').id === item.id;
          });
          if (saveItem) {
            newObjectItem = JSON.parse(JSON.stringify(objectItem));
            newObjectItem.quantity = Math.abs(objectItem.quantity - saveItem._previousAttributes.quantity);
            newObjectItem.amount = newObjectItem.quantity * newObjectItem.price;
          } else {
            newObjectItem = objectItem;
          }
        }
        eventName ? eventData.ecommerce.add.products.push(newObjectItem) : eventData.ecommerce.remove.products.push(newObjectItem);
        line.toProcess = false;
      }
      itemCounter++;
      return cartTotal;
    }
    function klaviyoLoader() {
      var promise = jQuery.Deferred();
      if (Configuration.dataLayer && Configuration.dataLayer.publicApi) {
        if (!window.klaviyo) {
          var klaviyoScript = jQuery.getScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + Configuration.dataLayer.publicApi);
          klaviyoScript.done(function () {
            var startingKlaviyo = setInterval(function () {
              if (window.klaviyo) {
                clearInterval(startingKlaviyo);

                promise.resolve();
              }
            }, 100);
          });
        } else {
          promise.resolve();
        }
      } else {
        promise.reject();
      }

      return promise;
    }
    function klaviyoIdentifyMe(userObj, forceIdentify) {
      var retVal = false;
      var cookieMail = Cookies.get('klaviyoEmailId');
      userObj.$email = userObj.$email || userObj.email;

      if (userObj.$email !== cookieMail) {
        Cookies.set('klaviyoEmailId', userObj.$email);
        // eslint-disable-next-line
        klaviyo.identify(userObj, function () {
          // eslint-disable-next-line
          klaviyo.track('Identified', userObj, function () {
            // eslint-disable-next-line
            var klaviyoDL = _.find(dataLayer, function (event) {
              return event.event === 'klaviyoIdentified';
            });
            if (!klaviyoDL) {
              GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: true } });
            } else if (forceIdentify) {
              GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: true, originCheckout: true } });
            }
            retVal = true;
          });
        });
      } else {
        // eslint-disable-next-line
        var klaviyoDL = _.find(dataLayer, function (event) {
          return event.event === 'klaviyoIdentified';
        });
        !klaviyoDL && GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: true } });
      }
      return retVal;
    }
    function gettingPDPComponent() {
      var promise = jQuery.Deferred();
      var runPDP = setInterval(function () {
        if (SC.Application.getComponent('PDP')) {
          clearInterval(runPDP);
          promise.resolve();
        }
      }, 100);
      return promise;
    }
    function pushPageViewEvent(url, name, self) {
      // eslint-disable-next-line
      var groupExists = Boolean(_.find(dataLayer, function (event) {
        return event.event === 'gtm.triggerGroup';
      }));
      var eventData = {
        event: 'pageView',
        data: {
          page: url,
          triggerGroup: groupExists,
          name: name && name !== '' && url !== '/' ? name :
            document.title ? document.title :
              SC.Application.layout && SC.Application.layout.currentView && SC.Application.layout.currentView.title
        }
      };

      Tracker.trigger('pageView', eventData, url);
      self.pushData(eventData);
    }
    function getUrlSearchParams(model) {
      var facets = model.get('facets');
      var facet = _.find(facets, function (i) {
        return i.id === 'custitem_manufacturer';
      });
      var hasFacet = false;

      var params = '';
      if (facet && facet.values) {
        hasFacet = _.find(facet.values, function (item) {
          return item.isActive;
        });
      }

      var completeUrl = '';
      var paginationData = model.options.data;

      if (hasFacet) {
        params = facet.url + '=';
        _.forEach(facet.values, function (item) {
          if (item.isActive) {
            params += item.url + ',';
          }
        });
      }

      if (paginationData.offset > 0) {
        var page = paginationData.offset / paginationData.limit + 1;
        completeUrl = '?page=' + page + params;
        completeUrl += paginationData.limit !== 24 ? '&show=' + paginationData.limit + '&' : String(params);
      } else if (paginationData.limit !== 24) {
        completeUrl = '?show=' + paginationData.limit + '&' + params;
      } else {
        completeUrl = '?' + completeUrl + params;
      }
      // eslint-disable-next-line
      var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (format.test(completeUrl.charAt(completeUrl.length - 1))) {
        completeUrl = completeUrl.slice(0, -1);
      }

      return completeUrl;
    }

    function updateProductListItems(items, eventData, listname, self) {
      _.each(items.models, function (item, index) {
        item.set('track_productlist_position', index + 1);
        item.set('track_productlist_category', self.getCategory());
        item.set('track_productlist_list', listname);
        var obj = convertToItemObj(item, item);
        delete obj.quantity;
        eventData.ecommerce.impressions.push(obj);
      });
    }

    return {
      mountToApp: function mountToApp(container) {
        var cart = container.getComponent('Cart');
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var plp = container.getComponent('PLP');
        this.domainSiteField = environment && environment.getConfig('cloudinaryImageGallery.field');
        var ga4MonsterPurchaseEnabled = environment && environment.getConfig('dataLayer.monsterGA4Purchase');
        window.klaviyo = null;

        !SC.isPageGenerator() && layout.on('afterShowContent', function afterShowContent() {
          if (!window.klaviyo) {
            klaviyoLoader().done(function () {
              var alreadyIdentified = false;
              // eslint-disable-next-line
              var gtmjs = _.find(dataLayer, function (event) {
                return event.event === 'gtm.js';
              });
              if (gtmjs && gtmjs.data && gtmjs.data.user && gtmjs.data.user.profileId) {
                var user = gtmjs.data.user;
                var objUsr = {
                  '$email': user.email,
                  '$first_name': user.firstName,
                  '$last_name': user.lastName,
                  '$organization': user.companyName,
                  '$phone_number': user.phoneNumber,
                  '$address1': user.address,
                  '$address2': user.addressAdditional,
                  '$city': user.city,
                  '$zip': user.zip,
                  '$region': user.region,
                  'RegionCode': user.regionCode,
                  '$country': user.country,
                  'CountryCode': user.countryCode
                };
                if (!user.firstName) {
                  var model = new DataLayerModel();
                  model.fetch({
                    data: {
                      customerid: user.profileId,
                      email: user.email
                    }
                  }).done(function (result) {
                    if (result) {
                      /* eslint-disable */
                      objUsr.$first_name = result.firstname;                      
                      objUsr.$last_name = result.lastname;
					  /* eslint-enable */
                      alreadyIdentified = klaviyoIdentifyMe(objUsr);
                    }
                  });
                } else {
                  alreadyIdentified = klaviyoIdentifyMe(objUsr);
                }
              } else {
                var locationHash = window.location.hash !== '' ? window.location.hash : window.location.search;
                if (locationHash) {
                  if (locationHash.indexOf('_kx=') !== -1) {
                    var kx = window.location.search.split('_kx=')[1].split('&')[0];
                    kx = kx && decodeURIComponent(kx);
                    model = new KlaviyoModel();
                    model.fetch({
                      data: { filter: kx }
                    }).done(function (result) {
                      if (result.success && result.body.data) {
                        alreadyIdentified = klaviyoIdentifyMe(result.body.data[0].attributes);
                      }
                    });
                  } else if (locationHash.indexOf('utm_email=') !== -1) {
                    var emailParam = window.location.search.split('utm_email=')[1].split('&')[0];
                    alreadyIdentified = klaviyoIdentifyMe({ $email: emailParam });
                  }
                }
                if (!alreadyIdentified) {
                  // eslint-disable-next-line
                  klaviyo.isIdentified().then(function (identified) {
                    identified && GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: true } });
                  });
                }
              }
            });
          } else {
            setTimeout(function () {
              if (Cookies.get('originIsProceedToCheckout')) {
                // eslint-disable-next-line
                var gtmjs = _.find(dataLayer, function (event) {
                  return event.event === 'gtm.js';
                });
                if (gtmjs && gtmjs.data && gtmjs.data.user && gtmjs.data.user.profileId) {
                  var user = gtmjs.data.user;
                  var objUsr = {
                    '$email': user.email,
                    '$first_name': user.firstName,
                    '$last_name': user.lastName,
                    '$organization': user.companyName,
                    '$phone_number': user.phoneNumber,
                    '$address1': user.address,
                    '$address2': user.addressAdditional,
                    '$city': user.city,
                    '$zip': user.zip,
                    '$region': user.region,
                    'RegionCode': user.regionCode,
                    '$country': user.country,
                    'CountryCode': user.countryCode
                  };

                  klaviyoIdentifyMe(objUsr, true);
                  Cookies.remove('originIsProceedToCheckout');
                }
              } else {
                // eslint-disable-next-line
                klaviyo.isIdentified().then(function (identified) {
                  // eslint-disable-next-line
                  var klaviyoDL = _.find(dataLayer, function (event) {
                    return event.event === 'klaviyoIdentified';
                  });
                  identified && !klaviyoDL && GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: true } });
                });
              }
            }, 1500);
          }
        });

        GoogleTagManager.pushData = _.wrap(GoogleTagManager.pushData,
          function wrapPushDataFunction(fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            processGTMJS();
            // eslint-disable-next-line
            var gtmjs = _.find(dataLayer, function (event) {
              return event.event === 'gtm.js';
            });
            if (gtmjs && gtmjs.data && gtmjs.data.user && !gtmjs.data.user.firstName) {
              var model = new DataLayerModel();
              model.fetch({
                data: {
                  customerid: gtmjs.data.user.profileId,
                  email: gtmjs.data.user.email
                }
              }).done(function (result) {
                if (result) {
                  gtmjs.data.user.firstName = result.firstname;
                  gtmjs.data.user.lastName = result.lastname;
                  /* eslint-disable */
                  gtmjs.data.user.contact_id = result.contact_id;
                  gtmjs.data.user.customer_id = result.customer_id;
                  gtmjs.data.user.user_id = result.user_id;
                  gtmjs.data.user.contact_ext_id = result.contact_ext_id;
                  gtmjs.data.user.customer_ext_id = result.customer_ext_id;
				  /* eslint-enable */
                }
              });
            }
          }
        );

        _.extend(GoogleTagManager, {

          trackProductView: function (product) {
            var item = product.getItem();
            var eventName = 'productView';
            var result = this.findCategoryAndListInDataLayer(product);
            var objectItem = convertToItemObj(item, product);
            delete objectItem.quantity;
            var eventData = {
              event: eventName,
              ecommerce: {
                detail: {
                  actionField: {
                    list: item.get('list') || result && result.list
                  },
                  products: [
                    objectItem
                  ]
                }
              },
              page: this.getCategory()

            };
            this.item = null;

            Tracker.trigger(eventName, eventData, item);
            this.pushData(eventData);

            return this;
          },
          trackTransaction: _.wrap(GoogleTagManager.trackTransaction, function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            Cookies.remove('proceedToCheckoutUniqueId');
            if (ga4MonsterPurchaseEnabled) {
              var transaction = _.toArray(arguments)[1];
              try {
                var confirmationNumber = transaction.get('confirmationNumber');
                if (!confirmationNumber) { return; }
                var sessionKey = 'ga4PurchaseFired_' + confirmationNumber;
                if (sessionStorage.getItem(sessionKey)) { return; }
                var items = [];
                transaction.get('products').each(function (product) {
                  items.push(convertToGA4Item(product));
                });
                // eslint-disable-next-line
                var currency = SC.getSessionInfo('currency').code || 'USD';
                var value = transaction.get('total');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'purchase',
                  ecommerce: {
                    transaction_id: confirmationNumber,
                    value: value,
                    currency: currency,
                    items: items
                  }
                });
                sessionStorage.setItem(sessionKey, '1');
              } catch (e) {
                console.warn('[GA4Purchase]', e);
              }
            }
          }),
          trackLogin: function trackLogin(event) {
            // Login data from FORM:
            var email = jQuery('[data-view="Login"] [name="email"]').val();

            var eventData = {
              event: 'login',
              data: {
                category: event.category,
                action: event.action,
                label: event.page || '/' + Backbone.history.fragment,
                value: event.value || ''
              },
              eventCallback: event.callback
            };
            eventData.data.user = { email: email };
            eventData.data.loggedIn = true;

            Tracker.trigger('login', eventData, event);
            this.pushData(eventData);
            if (Cookies.get('originIsProceedToCheckout')) {
              GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: false } });
            }

            return this;
          },
          trackRegister: function trackRegister(event) {
            // Register data from FORM:
            var email = jQuery('[data-view="Register"] [name="email"]').val();
            var firstName = jQuery('[data-view="Register"] [name="firstname"]').val();
            var lastName = jQuery('[data-view="Register"] [name="lastname"]').val();
            var companyName = jQuery('[data-view="Register"] [name="company"]').val();

            var eventData = {
              event: 'register',
              data: {
                category: event.category,
                action: event.action,
                label: event.page || '/' + Backbone.history.fragment,
                value: event.value || ''
              },
              eventCallback: event.callback
            };
            eventData.data.user = {
              email: email,
              firstName: firstName,
              lastName: lastName,
              companyName: companyName
            };
            eventData.data.loggedIn = true;

            Tracker.trigger('register', eventData, event);
            this.pushData(eventData);
            if (Cookies.get('originIsProceedToCheckout')) {
              GoogleTagManager.pushData({ event: 'klaviyoIdentified', klaviyo: { isIdentified: false } });
            }

            return this;
          },
          trackPageviewForCart: function (lines) {
            if (lines) {
              window.cartLines = {};
              var itemCounter = 1;
              var items = lines.items.models;
              var lengthToFixed = 2;
              var total = 0;
              var eventName = 'cartView';
              var eventData = {
                event: eventName,
                data: {
                  total: 0,
                  page: '',
                  items: [],
                  currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl
                }
              };

              window.cartLines = items;
              var quantityObj = {};
              items.forEach(function (line) {
                var item = line.get('item'), objectItem;

                var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
                var quantity = line.get('quantity');

                // Olds Quantity By Event
                // var quantityObj = window.quantityItems ? window.quantityItems : {};
                var positionInternalId = item.id + '-' + (itemCounter - 1);
                quantityObj[positionInternalId] = quantity;
                // window.quantityItems = quantityObj;

                var amount = line.get('amount');

                // Cart Total Logic
                total += amount;
                var stringAmount = amount.toString().split('.')[1];
                if (stringAmount && stringAmount.length > lengthToFixed) {
                  lengthToFixed = 3;
                }

                if (line.collection.length === itemCounter) {
                  eventData.data.total = parseFloat(total.toFixed(lengthToFixed));
                }

                eventData.data.checkoutUrl = checkoutUrl;
                eventData.data.page = lines.url;
                objectItem = convertToItemObj(item, line);
                objectItem.image = objectItem.imageUrl;
                objectItem.title = objectItem.name;
                eventData.data.items.push(objectItem);
                itemCounter++;
              });
              window.quantityItems = quantityObj;
              Tracker.trigger(eventName, eventData);
              this.pushData(eventData);
            }
            return this;
          },
          trackAddToCart: function (line) {
            window.cartLines = window.cartLines || {};
            var fromCart = Backbone.history.location.href.indexOf('cart') !== -1;
            var lengthToFixed = 2;
            var itemCounter = 1;
            var cartTotal = 0;
            var eventName = true;
            var notFoundLine = true;
            var index = 0;
            var self = this;
            if (fromCart) {
              cart.getLines().then(function (lines) {
                if (window.quantityItems && lines) {
                  // Serching the position of the item modified
                  while (index < lines.length && notFoundLine) {
                    if (lines[index].item.internalid === line.get('item').id) {
                      var itemInternalId = lines[index].item.internalid + '-' + index;
                      var itemCartQuantity = line.get('quantity');

                      if (typeof window.quantityItems[itemInternalId] === 'undefined') {
                        itemInternalId = getQuantityItemsId(line.get('item').id, lines.length);
                      }
                      line.toProcess = true;
                      if (window.quantityItems[itemInternalId] > itemCartQuantity) {
                        eventName = false;
                      } else {
                        eventName = true;
                      }
                      window.quantityItems[itemInternalId] = itemCartQuantity;
                      notFoundLine = false;
                    }
                    index++;
                  }
                  functionAddToCart(eventName, self, line, cartTotal, lengthToFixed, itemCounter);
                }
              });
            } else {
              line.toProcess = true;
              functionAddToCart(eventName, self, line, cartTotal, lengthToFixed, itemCounter);
            }
            return this;

          },
          trackCartUpdate: function (items, removeTriggered, lineToSearch) {
            var fromCart = Backbone.history.location.href.indexOf('cart') !== -1;
            var cartTotal = 0;
            var lengthToFixed = 2;
            var itemCounter = 1;
            var eventName = !(items && items.line_id);
            var eventNameText = 'cartItemsUpdate';
            var notFoundLine = true;
            var index = 0;
            var self = this;
            var itemRemoved;

            if (items) {
              var eventData = {
                event: 'cartItemsUpdate',
                data: {
                  items: [],
                  total: 0
                },
                ecommerce: {
                  currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl
                }
              };

              if (removeTriggered) {
                if (window.cartLines && window.cartLines.length > 0 && items.line_id) {
                  var cartLines = window.cartLines;
                  var lineFound = false;
                  index = 0;
                  while (index < cartLines.length && !lineFound) {
                    var itemIternalId = lineToSearch || items.line_id;
                    if (itemIternalId.indexOf(cartLines[index].get('internalid')) > -1) {

                      itemRemoved = convertToItemObj(cartLines[index].get('item'), cartLines[index]);
                      lineFound = true;
                    }
                    index++;
                  }
                }
              }

              // From Cart there are not ITEMS and When remove function was called
              var orderModel = Liveorder.getInstance();
              if (!items.length) {
                var itemList = orderModel.get('lines').models;
                if (itemRemoved) {
                  eventData.ecommerce.remove = { products: [itemRemoved] };
                  if (itemList.length === 0) {
                    Tracker.trigger(eventNameText, eventData);
                    self.pushData(eventData);
                    var event2CartEmpty = Object.assign({}, eventData);
                    event2CartEmpty['gtm.uniqueEventId'] = ++event2CartEmpty['gtm.uniqueEventId'];

                    event2CartEmpty.event = 'removeFromCart';
                    Tracker.trigger('removeFromCart', event2CartEmpty);
                    self.pushData(event2CartEmpty);
                    return this;
                  }
                }

                itemList.forEach(function (line) {
                  // Logic for removeFromCart function
                  if (fromCart) {
                    if (window.quantityItems) {
                      // Serching the position of the item modified
                      if (!removeTriggered) {
                        while (index < itemList.length && notFoundLine) {
                          if (lineToSearch && itemList[index].get('item').get('internalid') === lineToSearch
														|| itemList[index].get('item').get('internalid') === items.line.item.internalid) {
                            var itemInternalId = itemList[index].get('item').get('internalid') + '-' + index;
                            var itemCartQuantity = items.line.quantity;

                            if (typeof window.quantityItems[itemInternalId] === 'undefined') {
                              itemInternalId = getQuantityItemsId(
                                itemList[index].get('item').get('internalid'),
                                itemList.length
                              );
                            }

                            if (window.quantityItems[itemInternalId] > itemCartQuantity) {
                              eventName = false;
                            } else {
                              eventName = true;
                            }
                            itemList[index].toProcess = true;
                            notFoundLine = false;
                          }
                          index++;
                        }
                      } else {
                        eventName = false;
                      }
                    }
                  }
                  cartTotal = setValuesUpdated(line, eventData, eventName, cartTotal, lengthToFixed, itemCounter, itemRemoved);
                  itemCounter++;
                });
                window.cartLines = itemList;

              } else {
                // This logic run when you are NOT on the CART-VIEW
                items.forEach(function (line, it) {
                  if (!it) {
                    line.toProcess = true;
                  }
                  cartTotal = setValuesUpdated(line, eventData, eventName, cartTotal, lengthToFixed, itemCounter, itemRemoved);
                });
              }

              eventData.data.total = cartTotal;

              Tracker.trigger(eventNameText, eventData, items);
              this.pushData(eventData);
              if (itemRemoved) {
                var event2CartFilled = Object.assign({}, eventData);

                event2CartFilled['gtm.uniqueEventId'] = ++event2CartFilled['gtm.uniqueEventId'];

                event2CartFilled.event = 'removeFromCart';
                Tracker.trigger('removeFromCart', event2CartFilled);
                self.pushData(event2CartFilled);
              }
              return this;
            }

          },
          trackProceedToCheckout: function (e) {
            var eventName = 'proceedToCheckout';
            var eventData = {
              event: eventName,
              data: {
                name: 'proceedToCheckout',
                category: 'Checkout - User Interaction',
                action: 'Proceed To Checkout',
                label: e && e.page ? e.page : '/' + Backbone.history.fragment,
                value: e && e.value || '',
                callback: e,
                cartId: ''
              }
            };
            var executed = false;
            if (!Cookies.get('proceedToCheckoutUniqueId')) {
              var orderModel = Liveorder.getInstance();
              setCartIdCookie(orderModel);
            }
            if (!executed) {
              var uniqueTs = Cookies.get('proceedToCheckoutUniqueId');
              executed = true;
              if (uniqueTs) {
                eventData.data.cartId = uniqueTs.toString();
              }
            }
            Tracker.trigger(eventName, eventData, eventData.data);
            this.pushData(eventData);
            Cookies.set('originIsProceedToCheckout', 'T');
            return this;
          },
          trackProductListGeneric: function (eventName, items, listName) {
            var self = this;
            var total, id;
            if (plp.current_view) {
              var model = plp.current_view.model;
              var completeUrl = getUrlSearchParams(model);
              total = model.get('total');
              id = model.get('category') && model.get('category').id;

              if (id) {
                // eslint-disable-next-line
                this.tracking_product_list = true;
                var dataLayerModel = new DataLayerModel();
                dataLayerModel.fetch({
                  data: {
                    commercecategoryid: id
                  }
                }).then(function (result) {
                  // TODO: usually this is not working, we should check if we can improve this in future implementations.
                  if (result.data) {
                    var imageUrl = '/site/nabco/';
                    if (result.data.folder[0].text === 'categories') {
                      imageUrl += 'images/' + result.data.folder[0].text + '/' + result.data.name;
                    } else {
                      imageUrl += result.data.folder[0].text + '/' + result.data.name;
                    }

                    var eventData = {
                      event: eventName,
                      ecommerce: {
                        currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                        impressions: []
                      },
                      page: self.getCategory(),
                      list: listName,
                      label: listName,
                      name: model.get('category').get('name'),
                      results: total,
                      url: Backbone.history.location.origin + model.get('category').get('fullurl') + completeUrl,
                      id: model.get('category').id,
                      imageUrl: window.location.origin + imageUrl
                    };

                    updateProductListItems(items, eventData, listName, self);

                    Tracker.trigger(eventName, eventData, items);
                    self.pushData(eventData);
                  }
                });
              } else {
                var eventData = {
                  event: eventName,
                  ecommerce: {
                    currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                    impressions: []
                  },
                  page: self.getCategory(),
                  list: listName,
                  label: listName,
                  name: 'search',
                  results: total,
                  url: Backbone.history.location.origin + Backbone.history.location.pathname + completeUrl
                };
                updateProductListItems(items, eventData, listName, self);
                Tracker.trigger(eventName, eventData, items);
                self.pushData(eventData);
              }
            }
            // eslint-disable-next-line
            this.tracking_product_list = false;

            return this;
          },
          trackPageview: function (url) {
            var self = this;
            if (_.isString(url)) {
              if (plp && plp.current_view) {
                var model = plp.current_view.model;
                if (model.get('category')) {
                  if (model.get('category').get('canonical') === url.split('?')[0]) {
                    pushPageViewEvent(url, model.get('category').get('name'), self);
                  } else {
                    gettingPDPComponent().done(function () {
                      var item = SC.Application.getComponent('PDP').getItemInfo();
                      pushPageViewEvent(url, item && item.item.itemid, self);
                    });
                  }
                } else {
                  pushPageViewEvent(url, '', self);
                }
              } else {
                gettingPDPComponent().done(function () {
                  var item = SC.Application.getComponent('PDP').getItemInfo();
                  pushPageViewEvent(url, item && item.item.itemid, self);
                });
              }

            }

            return this;
          }
        });

        cart.on('afterUpdateLine', function onAfterUpdateLine(lineUpdated) {
          var foundLine = window.cartLines.find(function (line) {
            return line.get('internalid') === lineUpdated.line.internalid;
          });
          var lineToSearch;

          if (!foundLine) {
            // we have an issue trying to get the correct line, so we have to check for set.
            var orderModel = Liveorder.getInstance();
            window.cartLines = orderModel.get('lines').models;
            lineToSearch = lineUpdated.line.internalid;
            var splittedSet = Number(lineToSearch.split('set')[1]);

            splittedSet++;

            lineToSearch = lineToSearch.split('set')[0] + 'set' + splittedSet;
          }
          GoogleTagManager.trackCartUpdate(lineUpdated, false, lineToSearch);
        });
        cart.on('afterRemoveLine', function onAfterRemoveLine(lineUpdated) {
          GoogleTagManager.trackCartUpdate(lineUpdated, true);
          // when removing process so we don't lose references
          var index = 0;
          window.cartLines = window.cartLines.filter(function (line) {
            return line.get('internalid') !== lineUpdated.line_id;
          });

          var quantityObj = {};
          window.cartLines.forEach(function (line) {
            var item = line.get('item');
            var quantity = line.get('quantity');
            var positionInternalId = item.id + '-' + index;

            quantityObj[positionInternalId] = quantity;
            index++;
          });
          window.quantityItems = quantityObj;
        });
        cart.on('beforeUpdateLine', function () {
          var orderModel = Liveorder.getInstance();
          window.cartLinesBefore = orderModel.get('lines').models;
        });
      }
    };
  });

